<div class="values">
  <div class="row">
    <div class="col-xl-3 col-md-6" *ngFor='let prop of propsList'>
      <app-prop-element [elementData]=prop (onScroll)="handleScroll($event)"></app-prop-element>
    </div>
  </div>
</div>
